import { backfillUwEntriesRequired } from '@ps20-frontend/migrations';
import {
  StatePreV19,
  StateV19,
  WarenkorbAngebotPreV19,
  WarenkorbAngebotV19,
} from './19_migrate_uw_entries_required.interface';

const migrateWarenkorbAngebot = (angebot: WarenkorbAngebotPreV19): WarenkorbAngebotV19 => ({
  ...angebot,
  uw: backfillUwEntriesRequired(angebot.uw),
});

export const migrateUwEntriesRequired = (
  previousState: StatePreV19,
  newVersion: number,
): StateV19 =>
  ({
    ...previousState,
    version: newVersion,
    warenkorb: (previousState.warenkorb ?? []).map(migrateWarenkorbAngebot),
  }) as StateV19;
